var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNote({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.2699 12.1801L24.1266 17.0568C23.1466 21.2684 21.2099 22.9718 17.5699 22.6218C16.9866 22.5751 16.3566 22.4701 15.6799 22.3068L13.7199 21.8401C8.85488 20.6851 7.34988 18.2818 8.49322 13.4051L9.63655 8.51676C9.86988 7.52509 10.1499 6.66176 10.4999 5.95009C11.8649 3.12676 14.1866 2.36842 18.0832 3.29009L20.0316 3.74509C24.9199 4.88842 26.4132 7.30342 25.2699 12.1801Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5699 22.6219C16.8466 23.1119 15.9366 23.5202 14.8282 23.8819L12.9849 24.4885C8.35324 25.9819 5.91491 24.7335 4.40991 20.1019L2.91658 15.4935C1.42324 10.8619 2.65991 8.41186 7.29158 6.91853L9.13491 6.31186C9.61324 6.1602 10.0682 6.03186 10.4999 5.9502C10.1499 6.66186 9.86991 7.5252 9.63658 8.51686L8.49324 13.4052C7.34991 18.2819 8.85491 20.6852 13.7199 21.8402L15.6799 22.3069C16.3566 22.4702 16.9866 22.5752 17.5699 22.6219Z",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7466 9.95166L20.4049 11.3867",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.6035 14.4668L16.9868 15.3301",
    stroke: "#1B1C1E",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.3feaf947d37f1fd331a38c411f15b221.svg";
export { ForwardRef as ReactComponent };